import {combineReducers, configureStore} from "@reduxjs/toolkit";
import authReducer from "./reducer";
import videoPlayerReducer from "./player/playerSlice";
import activeTVSlice from "./activeTV/activeTVSlice";
import {contentQueries, userQueries} from "../api/modules";

const combine = combineReducers({
    user: authReducer,
    videoPlayer: videoPlayerReducer,
    tvContent: activeTVSlice,
    [userQueries.reducerPath]: userQueries.reducer,
    [contentQueries.reducerPath]: contentQueries.reducer,
});

const store = configureStore({
    reducer: combine,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({}).concat([
            userQueries.middleware,
            contentQueries.middleware
        ])
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;


export {store};
